import React from 'react';
import PropTypes from 'prop-types';
import {TableEvento} from "./components/evento/TableEvento";
import TableEditEventoGeneral from "./components/evento/TableEditEventoGeneral";
export const SeccionEvento = ({tipo, data, factura, reload}) => {
    return (
        <div className="mb-12">
            {tipo === 'S' && <TableEvento liquidacion={data}  factura={factura} reload={reload}/>}
            {tipo === 'N' && <TableEditEventoGeneral liquidacion={data}  factura={factura} reload={reload} />}
        </div>
    );
};


SeccionEvento.prototype = {
    tipo: PropTypes.string,
    data: PropTypes.array
}

SeccionEvento.defaultProps = {
    tipo: '',
    data: []
}
